import {connect} from "react-redux";
import {TransitAreaDisplay} from "../common-comps/TransitAreaDisplay";
import { showTransitAreaModal } from "../actions/modal";

export const TransitArea = connect(
  (state) => ({
    pseudoZones: state.m.pseudoZones,
    transit_areas: state.m.transit_areas,
  }),
  (dispatch) => ({
    showTransitAreaModal: (order) => dispatch(showTransitAreaModal(order)),
  })
)(TransitAreaDisplay);
